/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { verification } from '../fn/users-verification/verification';
import { Verification$Params } from '../fn/users-verification/verification';
import { verificationCode } from '../fn/users-verification/verification-code';
import { VerificationCode$Params } from '../fn/users-verification/verification-code';
import { VerificationResponseDto } from '../models/verification-response-dto';
import { VerificationSuccessResponseDto } from '../models/verification-success-response-dto';

@Injectable({ providedIn: 'root' })
export class ApiUsersVerificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `verificationCode()` */
  static readonly VerificationCodePath = '/api/v1/code';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verificationCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verificationCode$Response(params: VerificationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<VerificationResponseDto>> {
    return verificationCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verificationCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verificationCode(params: VerificationCode$Params, context?: HttpContext): Observable<VerificationResponseDto> {
    return this.verificationCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<VerificationResponseDto>): VerificationResponseDto => r.body)
    );
  }

  /** Path part for operation `verification()` */
  static readonly VerificationPath = '/api/v1/verification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verification$Response(params: Verification$Params, context?: HttpContext): Observable<StrictHttpResponse<VerificationSuccessResponseDto>> {
    return verification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verification(params: Verification$Params, context?: HttpContext): Observable<VerificationSuccessResponseDto> {
    return this.verification$Response(params, context).pipe(
      map((r: StrictHttpResponse<VerificationSuccessResponseDto>): VerificationSuccessResponseDto => r.body)
    );
  }

}
